<template>
  <Modal
    :show="showModal"
    :action-text="`Duplicate ${capitalizedDocumentTypeTitle}`"
    cancel-text=""
    :disabled="!valid"
    :width="modalWidth"
    @action="submit"
    @close="close"
  >
    <template #title>
      <slot name="title">
        Duplicate {{ capitalizedDocumentTypeTitle }}
      </slot>
    </template>

    <template #content>
      <slot name="content">
        Create a new
        {{ newDocumentType || documentTypeTitle2 }}
        based on the current {{ documentTypeTitle2 }}
        to save time and ensure consistency.

        <v-form
          ref="form"
          v-model="valid"
          class="mt-4"
        >
          <DpplTextField
            v-model="title"
            :label="`${capitalizedDocumentTypeTitle} Title`"
            :rules="titleRules"
            dense
          />
        </v-form>
      </slot>
    </template>
  </Modal>
</template>

<script>
import { startCase } from 'lodash-es';
import { mapState, mapActions } from 'pinia';
import validation from '@/helpers/validation';
import Modal from '@/components/shared/Modal.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import { useEditor } from '@/stores/editor/editor';

export default {
  name: 'DuplicateModal',
  components: {
    Modal,
    DpplTextField,
  },
  props: {
    docTitle: { type: String, default: '' },
    show: { type: Boolean, default: false },
    documentType: { type: String, default: 'job' },
    modalWidth: { type: String, default: 'medium' },
    newDocumentType: { type: String, default: '' },
  },
  emits: ['close', 'duplicate'],
  data() {
    return {
      title: '',
      valid: false,
      titleRules: validation.titleRules(),
    };
  },
  computed: {
    ...mapState(useEditor, ['showDuplicateModal', 'shareNames']),
    defaultTitle() {
      return `Copy of ${this.docTitle}`;
    },
    capitalizedDocumentTypeTitle() {
      return startCase(this.documentTypeTitle);
    },
    documentTypeTitle() {
      return {
        job_template: 'template',
        flagship: 'flagship job',
      }[this.documentType] || this.documentType;
    },
    documentTypeTitle2() {
      return {
        job_template: 'template',
        flagship: 'flagship job',
      }[this.documentType] || 'job post';
    },
    showModal() {
      return this.show || this.showDuplicateModal;
    },
  },
  watch: {
    showModal(oldVal, newVal) {
      if (newVal || oldVal) {
        this.title = this.defaultTitle;
      }
    },
  },
  methods: {
    ...mapActions(useEditor, ['setShowDuplicateModal']),
    submit() {
      this.setShowDuplicateModal(false);
      this.$emit('duplicate', {
        isPrivate: 1, // Private to me
        title: this.title,
      });
    },
    close() {
      this.setShowDuplicateModal(false);
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="less">
:deep(.v-chip.v-chip--size-default) {
  font-size: 12px;
}
</style>
